import { Typography } from "antd";

const { Title, Paragraph } = Typography;

function CommingSoon() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 200px)",
        textAlign: "center",
      }}
    >
      <Title level={1}>Coming Soon</Title>
      <Paragraph type="secondary">
        This feature is currently under development and will be available soon.
      </Paragraph>
    </div>
  );
}

export default CommingSoon;
